export const apiURL = 'https://api.mintopoly.io';
export const frontURL = 'https://www.mintopoly.io';
export const rootDomain = '.mintopoly.io';

export const eventStart = new Date('2023-12-10T00:00:00.000+00:00');
export const eventEnd = new Date('2024-01-15T23:59:59.999+00:00');
